export default [
    {
        path: '/course/details',
        name: '课堂详情',
        component: r => require.ensure([], () => r(require('@/views/course/details')), 'user')
    },
]


// WEBPACK FOOTER //
// ./src/router/routers/course.js